import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import type { GetProfileDataResponseDto } from "@/modules/auth/dtos/get-profile-data-response-dto";

import { ProfileService } from "../../services/profile-service";

type UseGetProfileQueryProps = {
  options?: UseQueryOptions<GetProfileDataResponseDto, unknown>;
};

export const useGetProfileQuery = ({
  options
}: UseGetProfileQueryProps = {}) => {
  return useQuery({
    queryKey: ["profile", "data"],
    queryFn: async () => await ProfileService.getProfileData(),
    ...options
  });
};
